/// Wraps the GaugeComponent, getting the actual value usingBlynkClientApi, doing a get from {thermometerToken}/pin/V2
import React, {useState, useEffect} from 'react';
import { useBlynkApi } from '../hooks/useBlynkApi';
import Gauge from './Gauge';

const TemperatureGauge = () => {
    const [temperature, setTemperature] = useState(null);
    const {getTemperature} = useBlynkApi();

    useEffect (() => {
        const fetchTemperature = async () => {
            const response = await getTemperature();
            setTemperature(response.toFixed(1));
        };

        // Call fetchTemperature immediately
        fetchTemperature();

        //TODO: this is kind of a hack. we'll probably have one function to refresh everything on the parent component, or use server side events.
        // Set up interval to fetchTemperature every minute
        const intervalId = setInterval(fetchTemperature, 60000); // 60000 ms = 1 min

        // Provide cleanup function to clear interval on component unmount or effect re-run
        return () => clearInterval(intervalId);

    }, [getTemperature]);

    return (
        <div className='temperature-gauge'>
            <Gauge min={5} max={40} actual={temperature} />
        </div>
    );
};

export default TemperatureGauge;